import React from 'react'
import styles from './SuccessView.module.css'
import AppPrimaryBtn from '../../components/ui/AppPrimaryBtn/AppPrimaryBtn'
import AppWrapper from '../../components/ui/AppWrapper/AppWrapper'
import { Link } from 'react-router-dom'

const SuccessView: React.FC = () => {
  return (
    <AppWrapper className="bg-appLightGray h-[80%]">
      <div className={styles.successCircleWrapper}>
        <i className="fas fa-check-circle text-white"></i>
      </div>
      <div className={styles.successWrapper}>Ваш платеж успешно принят в обработку</div>
      <div className={styles.actions}>
        <Link to="/home">
          <AppPrimaryBtn className="w-full">
            <span className="uppercase">Вернуться на главную</span>
          </AppPrimaryBtn>
        </Link>
      </div>
    </AppWrapper>
  )
}

export default SuccessView
